import Vue from 'vue';
import VueShepherd from 'vue-shepherd';

require('shepherd.js/dist/css/shepherd.css');

Vue.use(VueShepherd);
